
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/detailPackage.m",
      function () {
        return require("private-next-pages/product/detailPackage.m.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/product/detailPackage.m"])
      });
    }
  